<template>

  <div class="side_tab" @click.prevent="$emit('click', $event)">
    <a class="side_tab_link">{{ title }} <strong>{{ subtitle }}</strong>
      <slot />
    </a>
  </div>

</template>

<script>
export default {
  name: 'sidebar-tab',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>
